import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__piraeus_loan_terms',
    path: '/loans/piraeus-loan-terms/',
    component: () =>
      interopDefault(
        import(
          '~/pages/loans/piraeus-loan-terms.vue' /* webpackChunkName: "pages-loans-piraeus-loan-terms.vue" */
        )
      )
  }
]
